import React from 'react';
import { ConnectPatientScreen } from 'screens';
import { RoutePath } from 'types/enums';

const CAREGIVER_ROUTES = [{ path: RoutePath.CONNECT_PATIENT, element: <ConnectPatientScreen /> }];

export { CAREGIVER_ROUTES };
